/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { css, jsx } from '@emotion/react';
import axios from 'axios';
import React, { useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from './layout/Footer';
import Header from './layout/HeaderB';
import './Styles.css';

export default function Update() {
  const [title, setTitle] = useState('');
  const [desc, setDesc] = useState('');
  const [score, setScore] = useState('');
  const [file, setFile] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('image', file);
    formData.append('title', title);
    formData.append('desc', desc);
    formData.append('score', score);
    try {
      await axios.put(
        'https://mern-stack-restaurants-app.herokuapp.com/reviews/update/' + id,
        formData
      );
      setTitle('');
      setDesc('');
      setScore('');
      const notify = () => toast.success('Review has been updated!');
      notify();
    } catch (err) {
      const notify = () => toast.error('Review could not be updated!');
      notify();
    }
  };
  return (
    <React.Fragment>
      <Toaster />
      <Header />
      <Box
        css={{
          minHeight: 'calc(100vh - 80px)',
        }}
      >
        <Flex direction="row" wrap="wrap" justify="center" mb={10}>
          <Flex direction="column">
            <Heading
              css={css`
                text-align: center;
                @media (max-width: 350px) {
                  font-size: 16px;
                }
              `}
              as="u"
              mb={8}
            >
              Update a Review
            </Heading>
            <form
              onSubmit={handleSubmit}
              css={css`
                @media (max-width: 350px) {
                  font-size: 13px;
                }
              `}
            >
              <input
                type="text"
                placeholder="Title"
                value={title}
                size="30"
                autoFocus={true}
                onChange={e => setTitle(e.target.value)}
                css={{
                  padding: '10px 5px',
                  marginBottom: '10px',
                }}
              />
              <textarea
                css={{
                  display: 'block',
                  marginTop: '10px',
                }}
                placeholder="Write a review"
                value={desc}
                type="text"
                rows="4"
                cols="30"
                onChange={e => setDesc(e.target.value)}
              ></textarea>
              <input
                css={{
                  display: 'block',
                  marginTop: '20px',
                  width: 'auto',
                  padding: '10px 5px',
                }}
                type="number"
                placeholder="Give a score 1-5"
                value={score}
                autoFocus={true}
                onChange={e => setScore(e.target.value)}
              />
              <label
                for="fileInput"
                css={{
                  display: 'block',
                  marginTop: '20px',
                  width: '200px',
                  padding: '10px 5px',
                }}
              >
                Add an Image (jpg/jpeg/png/webp)
              </label>
              <input
                css={{
                  display: 'block',
                  marginTop: '20px',
                  padding: '10px 5px',
                }}
                type="file"
                name="image"
                id="fileInput"
                onChange={e => setFile(e.target.files[0])}
              />
              <Button
                type="submit"
                disabled={score < 1 || score > 5}
                mt={5}
                colorScheme="blue"
              >
                Update
              </Button>
            </form>
          </Flex>
        </Flex>
      </Box>
      <Footer />
      <Button
        onClick={() => {
          navigate(-1);
        }}
        css={css`
          position: fixed;
          zindex: 100;
          top: 35%;
          left: 10px;
          @media (max-width: 350px) {
            font-size: 13px;
          }
        `}
        colorScheme="blue"
      >
        Go back
      </Button>
    </React.Fragment>
  );
}
